import axios from "axios";
import { csrfMutationConfig } from "../lib/csrf";

export const SCENARIO_DATA_ENDPOINTS = Object.freeze({
  incidentTypes: "/api/digital-risk/incident-types/",
  assetTypes: "/api/digital-risk/asset-types/",
  assets: "/api/digital-risk/assets/",
  riskOwners: "/api/digital-risk/risk-owners/",
  treatmentOptions: "/api/digital-risk/treatment-options/",
  treatmentCosts: "/api/digital-risk/treatment-costs/",
  treatmentEffects: "/api/digital-risk/treatment-effects/",
  treatmentApplicability: "/api/digital-risk/treatment-applicability-rules/",
});

const collectionUrl = (family) => SCENARIO_DATA_ENDPOINTS[family];
const updateUrl = (family, id) => `${collectionUrl(family)}${id}/update/`;

export const createScenarioData = async (family, payload) =>
  axios.post(collectionUrl(family), payload, await csrfMutationConfig());

export const updateScenarioData = async (family, id, payload) =>
  axios.put(updateUrl(family, id), payload, await csrfMutationConfig());

export const patchScenarioData = async (family, id, payload) =>
  axios.patch(updateUrl(family, id), payload, await csrfMutationConfig());
